import React from "react";
import { Building2 } from "lucide-react";

import {
  HOUSING_PROGRAM_FULL_LABELS,
  HOUSING_PROGRAM_LABELS,
  HOUSING_PROGRAM_ROUTE,
  HousingProgram,
} from "../../utils/housingProgram";
import {
  BadgeRoot,
  CardOverlay,
  LearnMoreLink,
  ProgramFullName,
  ProgramLabel,
} from "./styles";

type HousingProgramBadgeProps = {
  program: HousingProgram;
  variant?: "compact" | "prominent";
  className?: string;
};

function stopParentLinkNavigation(event: React.MouseEvent<HTMLAnchorElement>) {
  event.stopPropagation();
}

export function HousingProgramBadge({
  program,
  variant = "compact",
  className,
}: HousingProgramBadgeProps) {
  const isProminent = variant === "prominent";

  return (
    <BadgeRoot
      $variant={variant}
      className={className}
      data-testid="housing-program-badge"
      data-housing-program={program}
      role="status"
      aria-label={`Imóvel enquadrado como ${HOUSING_PROGRAM_FULL_LABELS[program]}`}
    >
      <ProgramLabel $variant={variant}>
        <Building2 className="h-3.5 w-3.5 shrink-0 text-orange-600" aria-hidden />
        <span>{HOUSING_PROGRAM_LABELS[program]}</span>
        {isProminent && (
          <ProgramFullName>— {HOUSING_PROGRAM_FULL_LABELS[program]}</ProgramFullName>
        )}
      </ProgramLabel>
      <LearnMoreLink
        $variant={variant}
        to={HOUSING_PROGRAM_ROUTE}
        onClick={stopParentLinkNavigation}
        data-testid="housing-program-learn-more"
      >
        O que é isso?
      </LearnMoreLink>
    </BadgeRoot>
  );
}

type HousingProgramCardBadgeProps = {
  program: HousingProgram;
};

export function HousingProgramCardBadge({ program }: HousingProgramCardBadgeProps) {
  return (
    <CardOverlay>
      <HousingProgramBadge program={program} variant="compact" />
    </CardOverlay>
  );
}

export default HousingProgramBadge;
